import { createContext } from 'react'
import { io } from 'socket.io-client'

const socketLink = process.env.REACT_APP_SERVER_LINK || 'http://localhost:3001'
export const socket = io(socketLink)

export const SocketContext = createContext(io())
